export default __webpack_public_path__ + "static/media/loadingspinner.553dfd9f.svg";